module.exports = __webpack_public_path__ + "img/782.08cd0102.jpg";